"use client";

import { getDenomosLogo } from "@/constants";
import { PropsWithClassName } from "@/types";
import { useTheme } from "next-themes";
import Image from "next/image";

interface Props {
  description?: string;
  size?: number;
}

function Loading({
  description,
  size = 128,
  className,
}: PropsWithClassName<Props>) {
  const { theme } = useTheme();
  return (
    <div className={`grid place-items-center ${className ?? ""}`}>
      <Loader size={size} theme={theme} />
      {description ? <p className="mt-4 font-light">{description}</p> : null}
    </div>
  );
}

function Loader({ size = 24, theme = "light" }) {
  return (
    <Image
      width={size}
      height={size}
      src={getDenomosLogo(theme)}
      alt={"loader"}
      className="animate-pulse-infinite content-center object-contain"
    />
  );
}
// const Loader = ({ size = 24 }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox={`0 0 ${size} ${size}`}
//     height={size}
//     width={size}
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <g fill="none" fillRule="evenodd">
//       <circle cx={size / 2} cy={size / 2} r="10">
//         <animate
//           attributeName="r"
//           begin="0s"
//           dur="1.8s"
//           values={`1; ${size / 2}`}
//           calcMode="spline"
//           keyTimes="0; 1"
//           keySplines="0.165, 0.84, 0.44, 1"
//           repeatCount="indefinite"
//         />
//         <animate
//           attributeName="stroke-opacity"
//           begin="0s"
//           dur="1.8s"
//           values="1; 0"
//           calcMode="spline"
//           keyTimes="0; 1"
//           keySplines="0.3, 0.61, 0.355, 1"
//           repeatCount="indefinite"
//         />
//       </circle>
//       <circle cx={size / 2} cy={size / 2} r="1">
//         <animate
//           attributeName="r"
//           begin="-0.9s"
//           dur="1.8s"
//           values={`1; ${size / 2}`}
//           calcMode="spline"
//           keyTimes="0; 1"
//           keySplines="0.165, 0.84, 0.44, 1"
//           repeatCount="indefinite"
//         />
//         <animate
//           attributeName="stroke-opacity"
//           begin="-0.9s"
//           dur="1.8s"
//           values="1; 0"
//           calcMode="spline"
//           keyTimes="0; 1"
//           keySplines="0.3, 0.61, 0.355, 1"
//           repeatCount="indefinite"
//         />
//       </circle>
//       <circle cx={size / 2} cy={size / 2} r="1">
//         <animate
//           attributeName="r"
//           begin="-0.45s"
//           dur="1.8s"
//           values={`1; ${size / 2}`}
//           calcMode="spline"
//           keyTimes="0; 1"
//           keySplines="0.165, 0.84, 0.44, 1"
//           repeatCount="indefinite"
//         />
//         <animate
//           attributeName="stroke-opacity"
//           begin="-0.45s"
//           dur="1.8s"
//           values="1; 0"
//           calcMode="spline"
//           keyTimes="0; 1"
//           keySplines="0.3, 0.61, 0.355, 1"
//           repeatCount="indefinite"
//         />
//       </circle>
//     </g>
//   </svg>
// );

export default Loading;
